import { Box, Button, Divider, Flex, Image, Text } from "@chakra-ui/react";
import {  MdArrowRight } from "react-icons/md";

import Logo from '../../assets/gopass-logo.png'
import { Input } from "../../components/Form/Input";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { formLogin, validationLogin } from "../../schemas/login";
import { useLogin } from "../../hooks/useLogin";

export function Login() {
  const { handelSigin } = useLogin();

  const {
    register,
    handleSubmit,
  } = useForm<formLogin>({
    resolver: zodResolver(validationLogin),
  });

  const onSubmit = async (data: formLogin) => {
    await handelSigin(data)
  }

  return (
    <Flex width={"100%"} flexDir={"column"} minHeight={"100vh"}>
      <Box
        maxW={"xl"}
        justifyContent="center"
        margin={"0 auto"}
        width="100%"
        height={"100%"}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          minH={"100vh"}
        >
          <Box
            bgColor={"white"}
            borderWidth={1}
            borderStyle={"solid"}
            borderColor={"gray.50"}
            p={{
              xs: '4',
              md: '16'
            }}
            borderRadius={"base"}
            shadow={"lg"}
            gap={"8"}
            width={"100%"}
            m={{
              xs: '4',
              md: '8'
            }}
          >
            <Box
              as="form"
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              onSubmit={handleSubmit(onSubmit)}
            >
              <Image
                objectFit="contain"
                src={Logo}
                borderRadius={"base"}
                mb={2}
                width={120}
              />
              <Text fontSize={'xl'} fontWeight={'bold'} mt={2}>Login Agência</Text>
              <Divider my={2}/>

              <Input 
                type="email"
                label="Usuário"
                placeholder="Email"
                {...register("email")}
              />
               <Input 
                type="password"
                label="Senha"
                placeholder="Senha"
                {...register("password")}
              />
              <Button
                borderColor={"#9426B4"}
                mt={4}
                variant="solid"
                width={'100%'}
                colorScheme="purple"
                height={"14"}
                loadingText={"Aguarde"}
                type="submit"
              >
                <MdArrowRight /> Entrar
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
}
